export const userIsStudyCoordinator = (user) => {
  return !!user && user.is_chart_reviewer === false && user.is_site_admin === false && user.is_study_admin === false && user.is_pharma_vigilance === false && user.is_chart_creator === true
}

export const userIsInvestigator = (user) => {
  return !!user && user.is_chart_reviewer === true && user.is_site_admin === true && user.is_study_admin === false && user.is_pharma_vigilance === false && user.is_chart_creator === true
}

export const userIsPortalAdmin = (user) => {
  return !!user && user.is_chart_reviewer === false && user.is_site_admin === true && user.is_study_admin === true && user.is_pharma_vigilance === true && user.is_chart_creator === false
}

export const userIsPharmaVigilance = (user) => {
  return !!user && user.is_chart_reviewer === false && user.is_site_admin === false && user.is_study_admin === false && user.is_pharma_vigilance === true && user.is_chart_creator === false
}

export const userCanSeeAllRoutes = (user) => {
  return !!user && user.is_chart_reviewer === true && user.is_site_admin === true && user.is_study_admin === true && user.is_pharma_vigilance === true && user.is_chart_creator === true
}

export const userIsSuperUser = (user) => {
  return !!user && (user.is_superuser === true || user.can_view_incomplete_charts === true)
}

export const userIsDataManager = (user) => {
  return !!user && user.is_data_manager === true
}


export const userRegionIsUS = (user) => {
  if (user && user.region && user.region.toLowerCase() === 'default') {
    return true
  }

  return false
}

export const userRegionIsEU = (user) => {
  if (user && user.region && user.region.toLowerCase() === 'eu') {
    return true
  }

  return false
}


export const getFullName = (user) => {
  if (user) {
    return `${user.first_name} ${user.last_name}`
  }
  return 'N/A'
}

export const userCanOnlyViewReadOnlyCharts = (user) => {
  return !!user && user.is_chart_reviewer === false && user.is_site_admin === false && user.is_study_admin === false && user.is_pharma_vigilance === false && user.is_chart_creator === false && user.can_view_incomplete_charts === true
}